module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/3e4e9455961bc075e5ea64069e878254.png";